<template>
  <div>
    <div class="row">
      <div class="col-12 d-flex my-auto">
        <div class="dropdown">
          <button class="btn-primary dropdown-toggle" id="detailDropdown" type="button" data-toggle="dropdown">
            Wählen...
          </button>
          <div class="dropdown-menu" aria-labelledby="detailDropdown">
            <a class="dropdown-item"
               href="#"
               @click="selectDetail(detail)"
               v-for="detail in details"
               :key="detail.id">
              {{ detail.name }}
            </a>
          </div>
        </div>
        <div class="flex-grow-1 ml-1">
          <input type="text"
                 class="form-control"
                 v-model="detailName"
                 placeholder="Name des Details"/>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <div class="row">
          <div class="col-12 h5">
            HTML
          </div>
          <div class="col-12">
            <textarea v-model="detailContent" rows="8" class="form-control"></textarea>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-12 h5 text-muted">
            Vorschau
          </div>
          <div class="col-12 border rounded bg-white p-3">
            <span class="small" v-html="detailContent"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-right">
        <button class="btn btn-primary"
                :disabled="mode !== 'edit'"
                @click="change">
          Ändern
        </button>
        <button class="btn btn-success ml-1"
                @click="create">
          Neu
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number
  },
  data() {
    return {
      details: [],
      selectedDetail: null,
      detailName: null,
      detailContent: null
    }
  },
  computed: {
    mode() {
      if (this.selectedDetail?.id)
        return 'edit'
      return 'create'
    }
  },
  methods: {
    selectDetail(productDetail) {
      this.selectedDetail = productDetail
      this.detailName = productDetail?.name
      this.detailContent = productDetail?.content
    },
    loadDetails() {
      return this.$api.get('/product-details')
          .then(res => this.details = res.data)
          .catch(err => this.handleError(err))
    },
    async create() {
      let pd = await this.$api.put('/product-details', {
        name: this.detailName,
        content: this.detailContent
      }).then(res => {
        return res.data
      }).catch(err => this.handleError(err))
      this.showInfo(pd.name + " erstellt und gespeichert.")
      await this.loadDetails()
      this.selectDetail(pd)
    },
    async change() {
      let pd = await this.$api.post(`/product-details/${this.selectedDetail.id}`, {
        id: this.selectedDetail.id,
        name: this.detailName,
        content: this.detailContent
      }).then(res => {
        return res.data
      }).catch(err => this.handleError(err))
      this.showInfo(pd.name + " gespeichert.")
      await this.loadDetails()
      this.selectDetail(pd)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const vm = this
          this.$nextTick(() => vm.selectDetail(vm.details.find(d => d.id === newVal)))
        } else
          this.selectDetail(null)
      }
    },
    selectedDetail(newVal) {
      if (newVal)
        this.$emit('select', newVal.id)
    }
  },
  activated() {
    this.loadDetails()
  },
  mounted() {
    this.loadDetails()
  }
}
</script>
